import { motion } from "framer-motion";
import { useAuth } from "../contexts/AuthContext";
import Login from "./Login";
export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="relative min-h-screen">
        <main className="relative min-h-screen bg-gradient-to-b from-[#0A0A0A]/95 via-[#111111]/95 to-[#0A0A0A]/95">
          <div className="absolute inset-0 bg-[url('/images/blur.jpeg')] bg-cover bg-center opacity-30 pointer-events-none blur-sm"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="min-h-screen flex items-center justify-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center max-w-xl mx-auto backdrop-blur-sm bg-black/20 p-8 rounded-2xl border border-white/10"
              >
                <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                  Giriş Yapmanız Gerekiyor
                </h1>
                <p className="text-xl text-gray-400 mb-8">
                  İndirimleri görebilmek için lütfen giriş yapın.
                </p>
                <div className="flex justify-center">
                  <Login />
                </div>
              </motion.div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return <>{children}</>;
};
